import { createFileRoute, Outlet, useMatchRoute } from '@tanstack/react-router';
import AgentLayout from '@/features/agent/layouts/AgentLayout';
import NotFoundPage from '@/features/agent/errors/NotFoundPage';
import ErrorPage from '@/features/agent/errors/ErrorPage';

export const Route = createFileRoute('/agent')({
  component: AgentRoot,
  notFoundComponent: NotFoundPage,
  errorComponent: ErrorPage,
});

function AgentRoot() {
  const matchRoute = useMatchRoute();

  // 独自レイアウトを持つページや、Rails Viewを使っているページを除外
  const excludedPaths = [
    '/agent/job_sources', // Rails View
    '/agent/outer_job_posts', // Rails View
    '/agent/trial/tutorial',
    '/agent/trial/account/link',
  ];

  // 現在のパスが除外対象かチェック
  const isExcluded = excludedPaths.some((path) => matchRoute({ to: path, fuzzy: true }));

  // 除外対象の場合はレイアウトなしで表示
  if (isExcluded) {
    return <Outlet />;
  }

  // React SPAページの場合はAgentLayoutを適用
  return (
    <AgentLayout>
      <Outlet />
    </AgentLayout>
  );
}
